// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"NotificationsLayout__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/NotificationsLayout/NotificationsLayout.scss
 ** module id = 954
 ** module chunks = 1
 **/